import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  { path: 'messages', redirectTo: 'messages/list', pathMatch: 'full' },
  {
    path: 'messages',
    children: [
      {
        path: 'list',
        loadComponent: () => import('./list/messages-list.component').then((m) => m.MessagesListComponent),
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class messagesRoutingModule {
  static routes = admin;
}
